import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordValidator(config: PasswordValidatorConfig = new PasswordValidatorConfig()): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value.toString();

    return value.length < config.minLength ||
      count(value, isUppercase) < config.minUpperCase ||
      count(value, isLowercase) < config.minLowercase ||
      count(value, isDigit) < config.minDigits ||
      count(value, isSpecial) < config.minSpecial
      ? { password: { value: control.value } }
      : null;
  };
}

function isDigit(character: string): boolean {
  return /[0-9]/.test(character);
}

function isSpecial(character: string): boolean {
  return /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(character);
}

function isUppercase(character: string): boolean {
  return isLetter(character) && character === character.toLocaleUpperCase();
}

function isLowercase(character: string): boolean {
  return isLetter(character) && character === character.toLocaleLowerCase();
}

function isLetter(character: string): boolean {
  return !isWhitespace(character) && !isDigit(character) && !isSpecial(character);
}

function isWhitespace(character: string): boolean {
  return /[\s]/.test(character);
}

function count(value: string, test: (character: string) => boolean): number {
  return value.split('').filter(test).length;
}

export class PasswordValidatorConfig {
  constructor(
    public minLength = 8,
    public minLowercase = 1,
    public minUpperCase = 1,
    public minDigits = 1,
    public minSpecial = 0,
  ) {}
}
